import { render, staticRenderFns } from "./SvgSprite.vue?vue&type=template&id=796bb4a8&scoped=true"
import script from "./SvgSprite.vue?vue&type=script&lang=js"
export * from "./SvgSprite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796bb4a8",
  null
  
)

export default component.exports